<div class="ac-shell">
  <div class="ac-page-header">
      <h1>Accounting Dashboard</h1>
      
    <div class="ac-header-actions">

      <div class="ac-filter-wrap">
        <label class="ac-filter-label">Period:</label>
        <select class="ac-filter-select" [(ngModel)]="selectedPeriod" (change)="selectPeriod(selectedPeriod)">
          <option *ngFor="let p of periods" [value]="p">{{ p }}</option>
        </select>
      </div>

      <div class="sd-header-actions">
        <button class="sd-btn sd-btn-primary" (click)="refreshAll()">
          <i class="pi pi-sync"></i> Refresh
        </button>
      </div>

    </div>
  </div>

  <div class="ac-kpi-grid">

    <div class="ac-kpi-card kpi-indigo">
      <div class="ac-kpi-glow"></div>
      <div class="ac-kpi-top-row">
        <div class="ac-kpi-icon-wrap">
          <i class="pi pi-arrow-down-left"></i>
        </div>
        <button class="ac-due-btn" [disabled]="isDialogOpen" (click)="openTopRecords('receivables')">
          <i class="pi pi-clock"></i> Upcoming Dues
        </button>
      </div>
      <div class="ac-kpi-label">Total Receivables</div>
      <div class="ac-kpi-value">{{ formatINR( receivables?.totalAmount) }}</div><br>

      <div class="ac-progress-track">
        <div class="ac-progress-fill fill-indigo" [style.width]="receivablePercent + '%'"></div>
      </div>
      <div class="ac-progress-label">
        <span>Collection progress</span>
        <span class="ac-pct-badge pct-indigo">{{ receivablePercent | number:'1.0-0' }}%</span>
      </div>

      <div class="ac-overdue-row">
        <div class="ac-overdue-label">
          <i class="pi pi-exclamation-triangle" style="color:#d97706"></i>
          <span>Overdue: <strong>{{ formatINR(receivables?.overdue) }}</strong></span>
        </div>
        <button class="ac-toggle-btn" (click)="toggleOverdue($event)">
          <i class="pi" [class.pi-chevron-down]="!showOverduePopup" [class.pi-chevron-up]="showOverduePopup"></i>
        </button>
      </div>

      <div class="ac-breakdown-panel" [class.open]="showOverduePopup">
        <div class="ac-bk-row"><span class="ac-bk-label">1 – 15 Days</span>
          <span class="ac-bk-val">{{ formatINR(receivables?.days15 || 0) }}</span>
        </div>
        <div class="ac-bk-row"><span class="ac-bk-label">16 – 30 Days</span>
          <span class="ac-bk-val">{{ formatINR(receivables?.days30 || 0) }}</span>
        </div>
        <div class="ac-bk-row"><span class="ac-bk-label">31 – 45 Days</span>
          <span class="ac-bk-val">{{ formatINR(receivables?.days45 || 0) }}</span>
        </div>
        <div class="ac-bk-row ac-bk-bold"><span class="ac-bk-label">Above 45 Days</span>
          <span class="ac-bk-val danger">{{ formatINR(receivables?.above45 || 0) }}</span>
        </div>
      </div>
    </div>

    <div class="ac-kpi-card kpi-rose">
      <div class="ac-kpi-glow"></div>
      <div class="ac-kpi-top-row">
        <div class="ac-kpi-icon-wrap">
          <i class="pi pi-arrow-up-right"></i>
        </div>
        <button class="ac-due-btn" [disabled]="isDialogOpen" (click)="openTopRecords('payables')">
          <i class="pi pi-clock"></i> Upcoming Dues
        </button>
      </div>
      <div class="ac-kpi-label">Total Payables</div>
      <div class="ac-kpi-value">{{ formatINR(payables?.totalAmount) }}</div><br>

      <div class="ac-progress-track">
        <div class="ac-progress-fill fill-rose" [style.width]="payablePercent + '%'"></div>
      </div>
      <div class="ac-progress-label">
        <span>Payment progress</span>
        <span class="ac-pct-badge pct-rose">{{ payablePercent | number:'1.0-0' }}%</span>
      </div>

      <div class="ac-overdue-row">
        <div class="ac-overdue-label">
          <i class="pi pi-exclamation-triangle" style="color:#d97706"></i>
          <span>Overdue: <strong>{{ formatINR(payables?.overdue) }}</strong></span>
        </div>
        <button class="ac-toggle-btn" (click)="togglePayableOverdue($event)">
          <i class="pi" [class.pi-chevron-down]="!showPayablePopup" [class.pi-chevron-up]="showPayablePopup"></i>
        </button>
      </div>

      <div class="ac-breakdown-panel" [class.open]="showPayablePopup">
        <div class="ac-bk-row"><span class="ac-bk-label">1 – 15 Days</span>
          <span class="ac-bk-val">{{ formatINR(payables?.days15 || 0) }}</span>
        </div>
        <div class="ac-bk-row"><span class="ac-bk-label">16 – 30 Days</span>
          <span class="ac-bk-val">{{ formatINR(payables?.days30 || 0) }}</span>
        </div>
        <div class="ac-bk-row"><span class="ac-bk-label">31 – 45 Days</span>
          <span class="ac-bk-val">{{ formatINR(payables?.days45 || 0) }}</span>
        </div>
        <div class="ac-bk-row ac-bk-bold"><span class="ac-bk-label">Above 45 Days</span>
          <span class="ac-bk-val danger">{{ formatINR(payables?.above45 || 0) }}</span>
        </div>
      </div>
    </div>

    <div class="ac-kpi-card kpi-emerald">
      <div class="ac-kpi-glow"></div>
      <div class="ac-kpi-top-row">
        <div class="ac-kpi-icon-wrap"><i class="pi pi-chart-bar"></i></div>
        <span class="ac-status-chip" [class.chip-pos]="netPosition >= 0" [class.chip-neg]="netPosition < 0">
          {{ netPosition >= 0 ? '↑ Surplus' : '↓ Deficit' }}
        </span>
      </div>
      <div class="ac-kpi-label">Net Position</div>
      <div class="ac-kpi-value" [class.val-pos]="netPosition >= 0" [class.val-neg]="netPosition < 0">
        {{ formatINR(netPosition) }}
      </div><br>
      <div class="ac-progress-track">
        <div class="ac-progress-fill fill-emerald" [style.width]="netPercent + '%'"></div>
      </div>
      <div class="ac-progress-label">
        <span>Net coverage</span>
        <span class="ac-pct-badge pct-emerald">{{ netPercent | number:'1.0-0' }}%</span>
      </div>
      <div class="ac-mini-stats">
        <div class="ac-mini-stat">
          <div class="ac-mini-label">Incoming</div>
          <div class="ac-mini-val green">{{ formatINR(totalIncoming) }}</div>
        </div>
        <div class="ac-mini-divider"></div>
        <div class="ac-mini-stat">
          <div class="ac-mini-label">Outgoing</div>
          <div class="ac-mini-val red">{{ formatINR(totalOutgoing) }}</div>
        </div>
      </div>
    </div>

    <div class="ac-kpi-card kpi-sky">
      <div class="ac-kpi-glow"></div>
      <div class="ac-kpi-top-row">
        <div class="ac-kpi-icon-wrap"><i class="pi pi-money-bill"></i></div>
        <span class="ac-status-chip chip-neutral">Cash Balance</span>
      </div>
      <div class="ac-kpi-label">Closing Cash</div>
      <div class="ac-kpi-value">{{ formatINR(closingCash) }}</div><br>
      <div class="ac-progress-track">
        <div class="ac-progress-fill fill-sky" style="width:70%"></div>
      </div>
      <div class="ac-mini-stats" style="margin-top:1rem">
        <div class="ac-mini-stat">
          <div class="ac-mini-label">Opening</div>
          <div class="ac-mini-val blue">{{ formatINR(openingCash) }}</div>
        </div>
        <div class="ac-mini-divider"></div>
        <div class="ac-mini-stat">
          <div class="ac-mini-label">Period</div>
          <div class="ac-mini-val blue">{{ selectedPeriod }}</div>
        </div>
      </div>
    </div>

  </div>

  <div class="ac-chart-card">
    <div class="ac-card-header">
      <div>
        <div class="ac-card-eyebrow">Monthly Trend</div>
        <div class="ac-card-title">Cash Flow Analysis</div>
      </div>
    </div>

    <div class="ac-cashflow-body">
      <div class="ac-chart-wrap">
        <canvas #cashflowChart></canvas>
      </div>

      <div class="ac-summary-panel">
        <div class="ac-summary-title">Summary</div>

        <div class="ac-summary-item">
          <div class="ac-summary-dot dot-blue"></div>
          <div class="ac-summary-content">
            <div class="ac-summary-label">Openinig Cash</div>
            <div class="ac-summary-val">{{ formatINR(openingCash) }}</div>
          </div>
        </div>

        <div class="ac-summary-item">
          <div class="ac-summary-dot dot-green"></div>
          <div class="ac-summary-content">
            <div class="ac-summary-label">Total Incoming</div>
            <div class="ac-summary-val green">{{ formatINR(totalIncoming) }}
              <span class="ac-sign">+</span>
            </div>
          </div>
        </div>

        <div class="ac-summary-item">
          <div class="ac-summary-dot dot-red"></div>
          <div class="ac-summary-content">
            <div class="ac-summary-label">Total Outgoing</div>
            <div class="ac-summary-val red">{{ formatINR(totalOutgoing) }}
              <span class="ac-sign">−</span>
            </div>
          </div>
        </div>

        <div class="ac-summary-divider"></div>

        <div class="ac-summary-item total-row">
          <div class="ac-summary-dot dot-purple"></div>
          <div class="ac-summary-content">
            <div class="ac-summary-label">Closing Cash</div>
            <div class="ac-summary-val purple">{{ formatINR(closingCash) }}
              <span class="ac-sign">=</span>
            </div>
          </div>
        </div>

        <div class="ac-ratio-bar">
          <div class="ac-ratio-label">Incoming / Outgoing Ratio</div>
          <div class="ac-ratio-track">
            <div class="ac-ratio-green" [style.width]="getIncomeRatioPct() + '%'"></div>
            <div class="ac-ratio-red" [style.width]="(100 - getIncomeRatioPct()) + '%'"></div>
          </div>
          <div class="ac-ratio-legend">
            <span class="rl-green">Incoming {{ getIncomeRatioPct() | number:'1.0-0' }}%</span>
            <span class="rl-red">Outgoing {{ (100 - getIncomeRatioPct()) | number:'1.0-0' }}%</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="ac-table-card">
    <div class="ac-card-header">
      <div>
        <div class="ac-card-eyebrow">Detailed View</div>
        <div class="ac-card-title">Monthly Cash Flow Breakdown</div>
      </div>
      <div class="ac-accent-stripe stripe-green"></div>
    </div>

    <div class="ac-table-scroll">
      <table class="ac-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Month</th>
            <th>Incoming</th>
            <th>Outgoing</th>
            <th>Net Flow</th>
            <!-- <th>Status</th>
            <th>Bar</th> -->
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of monthlyTable; let i = index">
            <td class="ac-rank">{{ i + 1 }}</td>
            <td class="ac-month">{{ row.month }}</td>
            <td class="ac-green-val">{{ formatINR(row.incoming) }}</td>
            <td class="ac-red-val">{{ formatINR(row.outgoing) }}</td>
            <td [class.ac-green-val]="row.net >= 0" [class.ac-red-val]="row.net < 0">
              {{ formatINR(row.net) }}
            </td>
            <!-- <td>
              <span class="ac-flow-badge" [class.badge-pos]="row.net >= 0" [class.badge-neg]="row.net < 0">
                <i class="pi" [class.pi-arrow-up]="row.net >= 0" [class.pi-arrow-down]="row.net < 0"></i>
                {{ row.net >= 0 ? 'Surplus' : 'Deficit' }}
              </span>
            </td>
            <td class="ac-bar-cell">
              <div class="ac-bar-track">
                <div class="ac-bar-in" [style.width]="row.inPct + '%'"></div>
                <div class="ac-bar-out" [style.width]="row.outPct + '%'"></div>
              </div>
            </td> -->
          </tr>
          <tr *ngIf="monthlyTable.length === 0">
            <td colspan="7" class="ac-empty">No data available for selected period</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>